import { combineReducers } from 'redux'

import anexosRecursoConcedido from './anexosRecursoConcedido'

export default combineReducers({ anexosRecursoConcedido })
